/* unplugin-vue-components disabled */import { render } from "./layout.vue?vue&type=template&id=1ec16540&lang=pug"
const script = {}

import exportComponent from "/Users/boringtu/Workspace/pri/kangxt-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__